<hpf-diaporama-form
        [diaporama]="diaporama"
        [loading]="diaporama.isNew()"
        (update)="onUpdate()"
        (delete)="onDelete()"
    ></hpf-diaporama-form>
<div class="container">
</div>
